var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",class:[
    { bg: _vm.backgroundColor || _vm.backgroundClass },
    _vm.backgroundColor ? '' : _vm.backgroundClass,
  ],style:(_vm.backgroundColor ? `backgroundColor: ${_vm.backgroundColor}` : '')},[_c('div',{staticClass:"content"},_vm._l((_vm.section.rows),function(row,index){return _c('div',{key:index + '-' + _vm.refreshKey,staticClass:"content-item"},[(row.type === 'carousel')?_c('CarouselRow',{attrs:{"row":row}}):(row.type === 'grid-xn')?_c('GridRow',{attrs:{"row":row}}):_c('ContentGeneratorRow',{attrs:{"row":row}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }